<script>
// import ComponentMapThumb from "./ComponentMapThumb.svelte";
//
// export let pageCopy;
// export let pageTitle;
// export let pageImage;
export let mapData;

//
let theTitle;
let baseURL = "https://strapi.understory.community";
let map1;
let map2;
let map3;
let map4;
// let theImg = pageImage[0];
// let imgURL = baseURL + theImg.formats.small.url // ""+ JSON.stringify(theImg.formats.small.url);
// let alt = theImg.alternativeText;
//
// if (pageTitle !== null) {
//     theTitle = pageTitle;

// } else {
//     theTitle = " ";
// }

if(mapData!== null){
map1 = mapData[0];
map2 = mapData[1];
map3 = mapData[2];
map4 = mapData[3];
}
</script>


<section>
	<h2>All maps</h2>
	<div>
		<nav class="fic--general-list">
		  <ul>
		      {#each mapData as map}
		      <li><a href="{map.ButtonLink}" title="meh" role="link">{map.Title}</a></li>
		      {/each}
		      
		  </ul>
		</nav>
	</div>
</section>